import styled from "@emotion/styled";

import { Heading4 } from "../headings/Headings";

export const HeadingBetween = styled(Heading4)`
  margin: 15px 15px 0;
`;
